import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import '../../../scss/controls/_progressbar.scss';

export interface ProgressBarInfo {
    numberComplete: number;
    total: number;
}

export const ProgressBar: React.FC<{
    id: string;
    progress: ProgressBarInfo;
    width?: string;
}> = ({ id, progress, width = '100%' }) => {
    const { numberComplete, total } = progress;

    // Guard against a zero/negative total and keep the fill between 0% and 100%
    const percentComplete = total > 0 ? Math.min(Math.max((numberComplete / total) * 100, 0), 100) : 0;
    const isComplete = percentComplete === 100;

    return (
        <div
            id={`progressBar_${id}`}
            className={`progressBar${isComplete ? ' complete' : ''}`}
            style={{ width }}
        >
            <div className='progressBar-label'>
                {isComplete && (
                    <FontAwesomeIcon
                        className='progressBar-checkmark'
                        icon={faCheck}
                    />
                )}
                {numberComplete} out of {total} complete
            </div>
            <div
                className='progressBar-track'
                role='progressbar'
                aria-valuemin={0}
                aria-valuemax={total}
                aria-valuenow={numberComplete}
            >
                <div
                    className='progressBar-fill'
                    style={{ width: `${percentComplete}%` }}
                />
            </div>
        </div>
    );
};
